<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    (click)="dismissModal()"
                    data-dismiss="modal"
                    aria-label="Close"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h3 class="modal-title">Upload attachment</h3>
            </div>
            <form
                id="fileUploadForm"
                name="fileUploadForm"
                novalidate
                autocomplete="off">
                <div class="modal-body">
                    <div class="container-fluid well">
                        <div class="row">
                            <div class="col-xs-12">
                                <div
                                    class="input-group"
                                    id="editArea"
                                    ng-class="{'has-error': fileUploadForm.fileToUpload.$invalid && fileUploadForm.fileToUpload.$dirty}">
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-file"
                                            ng-click="attachmentsUploadModalController.clickFileInput()"></i>
                                    </span>
                                    <input
                                        ng-file-select=""
                                        id="fileToUpload"
                                        ng-model="fileToUpload"
                                        name="fileToUpload"
                                        #uploadFileInput
                                        required=""
                                        (change)="uploadFileChange(uploadFileInput.files)"
                                        class="form-control ng-pristine ng-invalid ng-invalid-required ng-touched"
                                        type="file" />

                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-paper-clip"
                                            (click)="clickFileInput()"
                                            ng-click="attachmentsUploadModalController.clickFileInput()"
                                            tabindex="0"></i>
                                    </span>
                                </div>
                                <!-- <div
                                    class="help-block"
                                    ng-show="(fileUploadForm.fileToUpload.$error.selected || fileUploadForm.fileToUpload.$error.suffix) && fileUploadForm.fileToUpload.$dirty">
                                    <span>File with suffix of must be selected.</span>
                                </div>

                                <div
                                    class="help-block"
                                    ng-show="fileUploadForm.fileToUpload.$error.exists && fileUploadForm.fileToUpload.$dirty">
                                    <span>File name should be unique. File name provided already exists.</span>
                                </div>

                                <div
                                    class="help-block"
                                    ng-show="fileUploadForm.fileToUpload.$error.size && fileUploadForm.fileToUpload.$dirty">
                                    <span>File must not be empty.</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="modal-footer">
                <div class="form-group">
                    <button
                        id="uploadBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm upload"
                        (click)="validateAndUpload()"
                        ng-click="attachmentsUploadModalController.validateAndUpload(fileUploadForm)">
                        Upload
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>
                    <input
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        (click)="dismissModal()"
                        ng-click="$dismiss()"
                        value="Cancel"
                /></div>
            </div>
        </div>
    </div>
</div>
